<template>
  <RouterView />
</template>

<script>
export default {
  name: 'Auth'
};
</script>
